const getParticipantDetails = (subEventId: string, uuid: string) => {
  return {
    type: "START_PARTICIPANT_DETAILS_FETCH",
    payload: { subEventId, uuid },
  };
};
const getParticipants = (id: string, name?: string) => {
  return {
    type: "GET_EVENT_PARTICIPANTS",
    payload: { id, name: name ? name : null },
  };
};

const changeParticipantsData = (id: string, value: string, array: boolean) => {
  return {
    type: "CHANGE_PARTICIPANTS_DATA",
    payload: { id, value, array },
  };
};

const saveParticipantChanges = (uuid: string, eventId: string) => {
  return {
    type: "START_PARTICIPANT_PATCH_REQUEST",
    payload: { uuid, eventId },
  };
};

const participantActions = {
  getParticipantDetails,
  getParticipants,
  changeParticipantsData,
  saveParticipantChanges,
};

export default participantActions;
